// PastArticlesByYear.jsx
import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../config/firebase";
import { Link } from "react-router-dom";
import { groupThreadsByYearMonth } from "../../utils/threadUtils";

const PastArticlesByMonth = () => {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchThreads = async () => {
      try {
        const q = query(collection(db, "stories"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        const fetchedThreads = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setThreads(fetchedThreads);
      } catch (err) {
        console.error("スレッド取得失敗:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchThreads();
  }, []);

  if (loading) return <div>読み込み中...</div>;
  if (threads.length === 0) return <div>過去の記事はありません</div>;

  const threadsByMonth = groupThreadsByYearMonth(threads);

  return (
    <div>
{Object.keys(threadsByMonth)
  .sort((a, b) => {
    const [aYear, aMonth] = a.match(/\d+/g).map(Number);
    const [bYear, bMonth] = b.match(/\d+/g).map(Number);
    return bYear !== aYear ? bYear - aYear : bMonth - aMonth;
  })
  .map((yearMonth) => {
    const [year, month] = yearMonth.match(/\d+/g); // ["2025", "10"]
    return (
      <div key={yearMonth} style={{ marginBottom: "10px" }}>
        <Link to={`/library?year=${year}&month=${month}`}>
          {yearMonth}（{threadsByMonth[yearMonth].length}）
        </Link>
      </div>
    );
  })}

    </div>
  );
};

export default PastArticlesByMonth;
